import Enum from "../../../../../../enums/Enum";

const ProgressEnum = new Enum({
    PROGRESSING: {name: "Progressing"},
    MINIMAL_PROGRESS: {name: "Minimal Progress"}
});

export default ProgressEnum;
